import { render } from "./ProductDetailItem.vue?vue&type=template&id=9907d8de&scoped=true"
import script from "./ProductDetailItem.vue?vue&type=script&lang=js"
export * from "./ProductDetailItem.vue?vue&type=script&lang=js"

import "./ProductDetailItem.vue?vue&type=style&index=0&id=9907d8de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9907d8de"]])

export default __exports__